function getCarrierIdFromAuthData(authData) {
	const { 'custom:carrierId': carrierId } = authData?.attributes || {};
	return carrierId;
}

export default getCarrierIdFromAuthData;
